import { redirect } from 'react-router';
import { countryListQueryOptions } from '@/hooks/settings/use-country-list';
import ROUTES from '@/routes';
import { isAuthenticated } from '@/stores/auth';
import { addTranslateToast } from '@/stores/toast';
import { catchFetcherError } from '@/utils/fetcher';
import { queryClient } from '@/utils/query-client';

export async function authLayoutLoader() {
  if (await isAuthenticated()) {
    addTranslateToast({
      key: 'already-signed-in',
      type: 'info',
      message: 'auth.already-signed-in',
    });
    return redirect(ROUTES.MESSAGES.$path());
  }

  return {
    countryListPromise: queryClient.prefetchQuery(countryListQueryOptions).catch(catchFetcherError),
  };
}
